export const TASK_REQUEST = "TASK_REQUEST";
export const TASK_SUCCESS = "TASK_SUCCESS";

export const GET_TASK = "GET_TASK";
export const GET_TASK_HEADER_DATA = "GET_TASK_HEADER_DATA";

export const TASK_PLAYGROUND_REQUEST = "TASK_PLAYGROUND_REQUEST";
export const TASK_PLAYGROUND_REQUEST_SUCCESS = "TASK_PLAYGROUND_REQUEST_SUCCESS";

export const USER_TASK_START = "USER_TASK_START";
export const UPDATE_USER_TASK = "UPDATE_USER_TASK";

export const VALIDATE_USER_ANSWER = "VALIDATE_USER_ANSWER";
